export const permissionsLocationsReadonly = [
  "locations-full",
  "locations-readonly",
  "everything-full",
  "everything-readonly",
];
